import { getLayoutFn } from './getLayoutFn';

export * from './NavigationContext';
export * from './NavigationBurgerMenu';
export * from './types';

export const NextNavigationService = {
  getLayoutFn,
};
